/** @format */

/* cspell: disable */
import { MarketCode } from '@mpb-com/feather/enums';
import React, { Fragment } from 'react';

export function useTranslationByMarket(market: MarketCode, refCode: string) {
    switch (market) {
        case MarketCode.EN_US:
            return {
                preHeading: `Error 500 - Ref code: ${refCode}`,
                heading: 'Internal server error',
                message: (
                    <Fragment>
                        <p>
                            It looks like something on our side isn’t working
                            correctly. <br />
                            Please refresh the page or try again later. <br />
                            If you need help with a transaction, please visit
                            our help center.
                        </p>
                        <p>Sorry for any inconvenience.</p>
                    </Fragment>
                ),
                helpCentre: 'Help center',
            };
        case MarketCode.FR_BE:
        case MarketCode.FR_FR:
            return {
                preHeading: `Erreur 500 - Code de Référence : ${refCode}`,
                heading: 'Erreur de serveur interne',
                message: (
                    <Fragment>
                        <p>
                            Il semble que quelque chose de notre côté ne
                            fonctionne pas correctement. Rafraîchis la page
                            ci-dessous ou réessaie plus tard. <br />
                            Si tu as besoin d&apos;aide pour une transaction,
                            n&apos;hésite pas à consulter notre centre
                            d&apos;aide.
                        </p>
                        <p>Nous sommes navrés de ce désagrément.</p>
                    </Fragment>
                ),
                helpCentre: `Centre d'aide`,
            };
        case MarketCode.DE_AT:
        case MarketCode.DE_DE:
            return {
                preHeading: `Fehler 500 - Code: ${refCode}`,
                heading: 'Interner Serverfehler',
                message: (
                    <Fragment>
                        <p>
                            Es sieht so aus, als würde etwas auf unserer Seite
                            nicht richtig funktionieren. Aktualisieren die Seite
                            unten oder versuche es später noch einmal. <br />
                            Wenn du Hilfe bei einer Transaktion benötigst,
                            kannst du stattdessen auch unser Hilfe-Center
                            besuchen.
                        </p>
                        <p>Wir entschuldigen uns für die Unannehmlichkeiten.</p>
                    </Fragment>
                ),
                helpCentre: 'Hilfe-Center',
            };
        case MarketCode.NL_BE:
        case MarketCode.NL_NL:
            return {
                preHeading: `Error 500 - Ref code: ${refCode}`,
                heading: 'Interne server error',
                message: (
                    <Fragment>
                        <p>
                            Het lijkt erop dat iets aan onze kant niet goed
                            werkt.
                            <br />
                            Ververs de pagina hieronder of probeer het later
                            opnieuw. <br />
                            Als je hulp nodig hebt bij een transactie, kunt je
                            ook ons Helpcentrum bezoeken.
                        </p>
                        <p>Onze excuses voor het ongemak.</p>
                    </Fragment>
                ),
                helpCentre: 'Helpcentrum',
            };
        case MarketCode.IT_IT:
            return {
                preHeading: `Errore 500 - Codice di riferimento: ${refCode}`,
                heading: 'Errore interno del server',
                message: (
                    <Fragment>
                        <p>
                            Sembra che qualcosa non funzioni correttamente qui.
                            <br />
                            Aggiorna la pagina o riprova più tardi.
                            <br />
                            In alternativa, se hai bisogno di aiuto per una
                            transazione, puoi visitare il nostro centro
                            assistenza.
                        </p>
                        <p>Ci scusiamo per l&apos;inconveniente.</p>
                    </Fragment>
                ),
                helpCentre: 'Centro assistenza',
            };
        case MarketCode.ES_ES:
            return {
                preHeading: `Error 500 - Código de referencia: ${refCode}`,
                heading: 'Error interno del servidor',
                message: (
                    <Fragment>
                        <p>
                            Parece que algo por nuestra parte no está
                            funcionando bien.
                            <br />
                            Vuelve a cargar la página o inténtalo de nuevo más
                            tarde.
                            <br />
                            Si necesitas ayuda con una transacción, por favor
                            visita nuestro centro de ayuda.
                        </p>
                        <p>Disculpa las molestas.</p>
                    </Fragment>
                ),
                helpCentre: 'Centro de ayuda',
            };
        case MarketCode.PT_PT:
            return {
                preHeading: `Erro 500 – Ref. código: ${refCode}`,
                heading: 'Erro interno do servidor',
                message: (
                    <Fragment>
                        <p>
                            Parece que algo não está a funcionar corretamente.
                            <br />
                            Por favor, atualiza a página ou tenta novamente mais
                            tarde.
                            <br />
                            Se precisares de apoio relativamente a uma
                            encomenda, consulta o nosso Centro de Ajuda.
                        </p>
                        <p>Pedimos desculpa pelo incómodo.</p>
                    </Fragment>
                ),
                helpCentre: 'Centro de Ajuda',
            };
        default:
            return {
                preHeading: `Error 500 - Ref code: ${refCode}`,
                heading: 'Internal server error',
                message: (
                    <Fragment>
                        <p>
                            It looks like something our side isn’t working
                            correctly. <br />
                            Refresh the page below or try again later. <br />
                            Alternatively, if you need help with a transaction,
                            you can visit our help centre.
                        </p>
                        <p>Sorry for any inconvenience.</p>
                    </Fragment>
                ),
                helpCentre: 'Help Centre',
            };
    }
}
